// Serialize reads and mutations in this tab. A rejected request must not poison
// subsequent work. Never retry a write automatically after an ambiguous failure.
(() => {
  if (window.PerfectionCartQueue) return;
  let tail = Promise.resolve();
  window.PerfectionCartQueue = {
    async request(url, config) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        return await fetch(url, { ...config, signal: controller.signal });
      } finally {
        clearTimeout(timer);
      }
    },
    run(task) {
      const result = tail.then(task);
      tail = result.catch(() => {});
      return result;
    },
  };
})();
